import styled from 'styled-components';
import { v2Colors, v2FontFamily } from '../../../formInputsV2/styles/tokens';

export const UppyContainer = styled.div`
  .uppy-Dashboard-inner {
    height: 200px !important;
    background-color: #fff;
    border: 2px dashed rgba(130, 130, 130, 0.3);
    border-radius: 15px;
  }

  .uppy-Dashboard-AddFiles-info {
    display: block;
    margin-top: 30px !important;
    padding-top: 0 !important;
  }

  .uppy-Dashboard-AddFiles {
    border: none;
  }

  .uppy-Dashboard-note {
    color: #99dbb9;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .uppy-Dashboard-AddFiles-list {
    display: none;
  }

  .uppy-Dashboard-AddFiles-title {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 12px;
    margin-bottom: 50px;
  }

  .uppy-Dashboard-AddFiles-title::before {
    content: url(${(props) => props.icon});
    transform: scale(0.7);
  }

  .uppy-Dashboard-browse {
    font-size: 14px;
  }

  @media screen and (max-width: 1200px) {
    .uppy-Dashboard-AddFiles-info {
      margin-top: 0px !important;
    }
  }


  @media screen and (max-width: 768px) {
    .uppy-Dashboard-AddFiles-title {
      margin-bottom: 15px !important;
    }
  }
`;

// v2 look of the same Uppy dropzone (opted into with <UploaderBonifico v2 />).
export const UppyContainerV2 = styled.div`
  min-width: 0;

  .uppy-Dashboard,
  .uppy-Dashboard-inner {
    width: 100% !important;
    max-width: 100%;
  }

  .uppy-Dashboard-inner {
    height: 200px !important;
    background-color: ${v2Colors.primarySoft};
    border: 1.5px dashed ${v2Colors.primaryBorder};
    border-radius: 14px;
    transition: background-color 150ms ease, border-color 150ms ease;
  }

  .uppy-Dashboard-inner:hover {
    background-color: ${v2Colors.primarySoftHover};
    border-color: ${v2Colors.primary};
  }

  .uppy-Dashboard-AddFiles {
    border: none;
  }

  .uppy-Dashboard-AddFiles-list {
    display: none;
  }

  .uppy-Dashboard-AddFiles-title {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2px;
    margin-bottom: 0;
    font-family: ${v2FontFamily};
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    color: ${v2Colors.text};
  }

  .uppy-Dashboard-AddFiles-title::before {
    content: url(${(props) => props.icon});
    margin-bottom: 8px;
    transform: scale(0.75);
  }

  .uppy-Dashboard-browse {
    font-family: ${v2FontFamily};
    font-size: 14px;
    font-weight: 700;
    color: ${v2Colors.primary};
    text-decoration: underline;
  }

  .uppy-Dashboard-browse:hover,
  .uppy-Dashboard-browse:focus {
    color: ${v2Colors.primaryHover};
  }

  /* Uppy pins this to the bottom of the box (position: absolute); keep it in
     the normal flow under the text so the two can never overlap. */
  .uppy-Dashboard-AddFiles-info {
    position: static !important;
    display: block;
    width: 100%;
    margin-top: 12px !important;
    padding: 0 !important;
  }

  .uppy-Dashboard-note {
    max-width: 100%;
    margin: 0 auto;
    padding: 0 12px;
    font-family: ${v2FontFamily};
    font-size: 12.5px;
    font-weight: 700;
    letter-spacing: 0.05em;
    line-height: 1.4;
    color: ${v2Colors.primaryHover};
  }

  /* one line, except on very narrow screens where it has to wrap */
  @media (min-width: 420px) {
    .uppy-Dashboard-note {
      white-space: nowrap;
    }
  }
`;
